import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { HeartFilled } from "@ant-design/icons";
import {
  Layout,
  Menu,
  Button,
  Typography,
  Card,
  Form,
  Input,
  Select,
  message,
  Upload,
  Checkbox,
  Alert,
  Steps,
  Result,
  Spin
} from "antd";
import {
  UserOutlined,
  MailOutlined,
  LockOutlined,
  PhoneOutlined,
  GlobalOutlined,
  UploadOutlined,
  InstagramOutlined,
  FacebookOutlined,
  TikTokOutlined,
  CheckCircleOutlined,
  SafetyOutlined,
  ClockCircleOutlined
} from "@ant-design/icons";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { agencyService } from "../services/agencyService"; // Import du service
import { getMergedCountryOptions } from "../constants/countries"; // Import de la liste complète des pays
import { RECAPTCHA_CONFIG, SIGNUP_ADDRESS_FIELDS,SUPPORT_EMAIL  } from "../appConfig";
import logo from "../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../components/LanguageSelector";
import Countries from "./Countries";
const { Title, Text } = Typography;
const { Header, Content, Footer } = Layout;
const { Option } = Select;

const { Step } = Steps;

const SignUpForm = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [registeredEmail, setRegisteredEmail] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpForm] = Form.useForm();
  const history = useHistory();
  const [form] = Form.useForm();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { t } = useTranslation();
  const SUPPORTED_LANGS = ['fr', 'en', 'ar', 'es', 'ur'];
  const browserBaseLang = (navigator.language || '').split('-')[0].toLowerCase();
  const isBrowserLangUnsupported = !SUPPORTED_LANGS.includes(browserBaseLang);
  const [langBannerDismissed, setLangBannerDismissed] = useState(false);
  const showLangBanner = isBrowserLangUnsupported && !langBannerDismissed;

  // Gestionnaire pour l'inscription
  const handleSignUp = async (values) => {
    try {
      setLoading(true);
      setError(null);

      // Vérification des conditions
      if (!values.agreeToTerms) {
        throw new Error(t('signup.termsRequired'));
      }

      // Obtenir le token reCAPTCHA
      /*if (!executeRecaptcha) {
        throw new Error("reCAPTCHA n'est pas encore prêt");
      }
      
      const recaptchaToken = await executeRecaptcha('register-agency');
*/
if (SIGNUP_ADDRESS_FIELDS === false){
      values.address="N/A"; 
      values.city='N/A';
      values.zipCode="00000";
      values.country=Countries[0].id || Countries[0].value || 1001;
}
      // Préparer les données
      const agencyData = {
        agencyName: values.agencyName.trim(),
        agencyEmail: values.email.trim(),
        password: values.password,
        phoneNum: values.phoneNum,
        address: values.address,
        city: values.city,
        //countryCode: values.country, // Utilisé pour le mappage au countryId côté serveur
        //countryId:1001,
        countryId: values.country,
        currencyId:1,
        licenceNumber: values.licenceNumber || `AGC-${Date.now().toString().substring(7)}`,
        zipCode: values.zipCode || "16000",
        title: "Mr",
        managerFirstName: values.managerFirstName || "",
        managerLastName: values.managerLastName || "",
        language: "fr",
        //recaptchaToken, // Ajout du token reCAPTCHA
      };

      // Gestion du logo si présent
      let logoFile = null;
      if (values.logo && values.logo.length > 0 && values.logo[0].originFileObj) {
        logoFile = values.logo[0].originFileObj;
      }

      // Utilisation du service agencyService pour l'inscription
      await agencyService.register(agencyData, logoFile, /*recaptchaToken*/);
      
      // Stocker l'email pour la vérification OTP
      setRegisteredEmail(values.email.trim());
      
      // Passer à l'étape suivante (vérification OTP)
      setCurrentStep(1);
      
      // Démarrer le compteur pour le renvoi du code
      startResendCountdown();
      
      message.success(t('signup.signupSuccess'));

    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.detail || err.message || t('signup.signupError'));
      console.error('Erreur d\'inscription:', err);
    } finally {
      setLoading(false);
    }
  };
  
  // Fonction pour gérer la vérification du code OTP
  const handleVerifyOtp = async (values) => {
    try {
      setLoading(true);
      setError(null);

      // Obtenir le token reCAPTCHA pour la vérification OTP
    /*  if (!executeRecaptcha) {
        throw new Error("reCAPTCHA n'est pas encore prêt");
      }

      const recaptchaToken = await executeRecaptcha('verify_otp');
      */
      // Appel au service pour vérifier l'OTP avec le token reCAPTCHA
      await agencyService.verifyOtp(registeredEmail, values.otpCode, /*recaptchaToken*/);
      
      // Marquer l'OTP comme vérifié
      setOtpVerified(true);
      
      // Passer à l'étape finale
      setCurrentStep(2);
      
      message.success(t('signup.otpSuccess'));
      
    } catch (err) {
      setError(err.response?.data?.message || err.message || t('signup.otpError'));
      console.error('Erreur de vérification OTP:', err);
      
      // Réinitialiser le formulaire OTP si le code est incorrect
      otpForm.resetFields();
    } finally {
      setLoading(false);
    }
  };
  
  // Fonction pour renvoyer le code OTP
  const handleResendOtp = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Appel au service pour renvoyer l'OTP
      await agencyService.resendOtp(registeredEmail);
      
      message.success(t('signup.resendSuccess'));
      
      // Redémarrer le compteur pour le renvoi du code
      startResendCountdown();
      
    } catch (err) {
      setError(err.response?.data?.message || err.message || t('signup.resendError'));
      console.error('Erreur de renvoi OTP:', err);
    } finally {
      setLoading(false);
    }
  };
  
  // Fonction pour démarrer le compteur de renvoi
  const startResendCountdown = () => {
    setCountdown(60);
    const timer = setInterval(() => {
      setCountdown(prevCount => {
        if (prevCount <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);
  };

  const [countryOptions, setCountryOptions] = useState([]);
  useEffect(() => {
    setLoading(true);
    getMergedCountryOptions(true)
      .then((options) => setCountryOptions(options))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout className="layout-default layout-signup">
      <Header>
        <div className="header-col header-brand">
          <img src={logo} alt="Castrum eSIM Dashboard" style={{ height: '50px' }} />
        </div>
      </Header>

      <Content className="p-0">
        <div className="sign-up-header" style={{ paddingTop: '80px' }}>
          <div className="header-col header-brand">
                    <img src={logo} alt="Castrum eSIM Dashboard" style={{ height: '150px' }} />
                  </div>
          <div className="content">
            <Title>{t('signup.agencySignup')}</Title>
            <Text>{t('signup.subtitle')}</Text>
          </div>
        </div>

        <Card 
          className="card-signup" 
          bordered={false}
        >
          {/* Étapes d'inscription */}
          <Steps current={currentStep} className="mb-4">
            <Step title={t('signup.stepRegistration')} description={t('signup.stepRegistrationDesc')} icon={<UserOutlined />} />
            <Step title={t('signup.stepVerification')} description={t('signup.stepVerificationDesc')} icon={<SafetyOutlined />} />
            <Step title={t('signup.stepConfirmation')} description={t('signup.stepConfirmationDesc')} icon={<ClockCircleOutlined />} />
          </Steps>
          
          {showLangBanner && (
            <Alert
              message={t('auth.languageBanner')}
              description={<LanguageSelector />}
              type="info"
              showIcon
              closable
              className="mb-4"
              onClose={() => setLangBannerDismissed(true)}
            />
          )}

          {error && (
            <Alert
              message={t(error)}
              type="error"
              showIcon
              closable
              className="mb-4"
              onClose={() => setError(null)}
            />
          )}
          
          {/* Étape 1: Formulaire d'inscription */}
          {currentStep === 0 && (
            <div>
              <h3>{t('signup.agencyInfoSection')}</h3>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSignUp}
                initialValues={{ agreeToTerms: false }}
              >
                <Form.Item
                  name="agencyName"
                  label={t('signup.agencyNameLabel')}
                  rules={[
                    { required: true, message: t('signup.agencyNameRequired') },
                    { min: 3, message: t('signup.agencyNameMinLength') }
                  ]}
                >
                  <Input prefix={<UserOutlined />} />
                </Form.Item>

                <Form.Item
                  name="email"
                  label={t('signup.emailLabel')}
                  rules={[
                    { required: true, message: t('signup.emailRequired') },
                    { type: 'email', message: t('signup.emailInvalid') }
                  ]}
                >
                  <Input prefix={<MailOutlined />} />
                </Form.Item>

                <Form.Item
                  name="password"
                  label={t('signup.passwordLabel')}
                  rules={[
                    { required: true, message: t('signup.passwordRequired') },
                    { min: 8, message: t('signup.passwordMinLength') },
                    { 
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s])\S+$/,
                      message: t('signup.passwordComplexity')
                    }
                  ]}
                >
                  <Input.Password prefix={<LockOutlined />} />
                </Form.Item>

                <Form.Item
                  name="phoneNum"
                  label={t('signup.phoneLabel')}
                  rules={[
                    { required: true, message: t('signup.phoneRequired') },
                    { 
                      pattern: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                      message: t('signup.phoneInvalid')
                    }
                  ]}
                >
                  <Input prefix={<PhoneOutlined />} />
                </Form.Item>
{process.env.SIGNUP_ADDRESS_FIELDS === 'true' && (<>
                <Form.Item
                  name="address"
                  label={t('signup.addressLabel')}
                  rules={[{ required: true, message: t('signup.addressRequired') }]}
                >
                  <Input prefix={<GlobalOutlined />} />
                </Form.Item>

                <Form.Item
                  name="city"
                  label={t('signup.cityLabel')}
                  rules={[{ required: true, message: t('signup.cityRequired') }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="zipCode"
                  label={t('signup.postalCodeLabel')}
                  rules={[{ required: true, message: t('signup.postalCodeRequired') }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="country"
                  label={t('signup.countryLabel')}
                  rules={[{ required: true, message: t('signup.countryRequired') }]}
                >
                  <Select showSearch optionFilterProp="children">
                    {countryOptions.map((country) => (
                      <Option key={country.id || country.value} value={country.id || country.value}>
                        {country.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                </>)}
                
                <h3 style={{ marginTop: '20px' }}>{t('signup.managerInfoSection')}</h3>
                
                <Form.Item
                  name="managerFirstName"
                  label={t('signup.managerFirstNameLabel')}
                  rules={[{ required: true, message: t('signup.managerFirstNameRequired') }]}
                >
                  <Input prefix={<UserOutlined />} />
                </Form.Item>
                
                <Form.Item
                  name="managerLastName"
                  label={t('signup.managerLastNameLabel')}
                  rules={[{ required: true, message: t('signup.managerLastNameRequired') }]}
                >
                  <Input prefix={<UserOutlined />} />
                </Form.Item>

                

                <Form.Item
                  name="agreeToTerms"
                  valuePropName="checked"
                  rules={[
                    { 
                      validator: (_, value) =>
                        value ? Promise.resolve() : Promise.reject(t('signup.agreeToTermsRequired'))
                    }
                  ]}
                >
                  <Checkbox>
                    {t('signup.agreeToTermsText')} <Link to="/terms">{t('signup.termsLinkText')}</Link>
                  </Checkbox>
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                  >
                    {loading ? t('signup.registeringButton') : t('signup.registerButton')}
                  </Button>
                </Form.Item>

                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Text>{t('signup.alreadyRegistered')} </Text>
                  <Link to="/login">
                    {t('signup.loginLink')}
                  </Link>
                </div>
              </Form>
            </div>
          )}
          
          {/* Étape 2: Vérification OTP */}
          {currentStep === 1 && (
            <div style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
              <h3>{t('signup.otpVerificationTitle')}</h3>
              <p>
                {t('signup.otpInstructions', { email: registeredEmail })}
              </p>
              
              <Form
                form={otpForm}
                layout="vertical"
                onFinish={handleVerifyOtp}
              >
                <Form.Item
                  name="otpCode"
                  rules={[
                    { required: true, message: t('signup.otpRequired') },
                    { 
                      pattern: /^[0-9]{6}$/, 
                      message: t('signup.otpDigits')
                    }
                  ]}
                >
                  <Input
                    size="large"
                    placeholder={t('signup.otpPlaceholder')}
                    style={{ textAlign: 'center', letterSpacing: '8px', fontSize: '20px' }}
                    maxLength={6}
                  />
                </Form.Item>
                
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                  >
                    {t('signup.verifyCodeButton')}
                  </Button>
                </Form.Item>
              </Form>
              
              <div style={{ marginTop: '20px' }}>
                <Text type="secondary">
                  {t('signup.noCodeReceived')}
                </Text>
                <br />
                {countdown > 0 ? (
                  <Text type="secondary">
                    {t('signup.resendCodeCountdown', { countdown })}
                  </Text>
                ) : (
                  <Button 
                    type="link" 
                    onClick={handleResendOtp} 
                    disabled={countdown > 0 || loading}
                  >
                    {t('signup.resendCodeButton')}
                  </Button>
                )}
              </div>
            </div>
          )}
          
          {/* Étape 3: Confirmation d'inscription */}
          {currentStep === 2 && (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <Result
                status="success"
                title={t('signup.successTitle')}
                subTitle={
                  <div>
                    <p>{t('signup.successPending')}</p>
                    <p>{t('signup.successEmailActivation')}</p>
                    <p>{t('signup.successContactUs')} <strong>{SUPPORT_EMAIL}</strong></p>
                  </div>
                }
                extra={[
                  <Button 
                    key="login" 
                    type="primary"
                    onClick={() => history.push('/login')}
                  >
                    {t('signup.goToLoginButton')}
                  </Button>
                ]}
              />
            </div>
          )}
          
        </Card>
      </Content>

      <Footer>
        <Menu mode="horizontal">
          <Menu.Item>{t('footer.company')}</Menu.Item>
          <Menu.Item>{t('footer.aboutUs')}</Menu.Item>
          <Menu.Item>{t('footer.teams')}</Menu.Item>
          <Menu.Item>{t('footer.products')}</Menu.Item>
          <Menu.Item>{t('footer.blogs')}</Menu.Item>
          <Menu.Item>{t('footer.pricing')}</Menu.Item>
        </Menu>
        <Menu mode="horizontal" className="menu-nav-social">
          <Menu.Item>
            <Link to="#">{<FacebookOutlined />}</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">{<TikTokOutlined />}</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">{<InstagramOutlined />}</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">
              <svg
                width="18"
                height="18"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"></path>
              </svg>
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="#">{"other"}</Link>
          </Menu.Item>
        </Menu>
        
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <LanguageSelector />
        </div>
        
        <div className="copyright">
            © 2025, made with
            {<HeartFilled />} by
            <a href="#pablo" className="font-weight-bold" target="_blank">
              TransaSim
            </a>
            for a better eSim experience.
          </div>
      </Footer>
    </Layout>
  );
};

const SignUp = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_CONFIG.siteKey}>
      <SignUpForm />
    </GoogleReCaptchaProvider>
  );
};

export default SignUp;